
import { Box, Divider, Table, IconButton, TableFooter, TableCell, TableBody, TableContainer, TableHead, TableRow, Grid, Typography, Tooltip, TextField, useTheme, Checkbox, Button } from "@mui/material";
import { styled } from '@mui/material/styles';
import  { useState, useEffect } from "react";
import CallAlertBar from "../../../Layout/Alertbar";
import 'dayjs/plugin/customParseFormat';
import Close from '@mui/icons-material/Close';
import useSalaryStructureCRUD from "../../../hooks/useSalaryStructure";
import useSalaryStructureDetailByID from "../../../hooks/useSalaryStructureDetailById";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import EditIcon from '@mui/icons-material/Edit';
import { tokens } from "../../../theme/theme";



const AddNewSalaryStructure = ({ handlecallback, editSalaryStructureID, editSalaryStructureCode }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [disableCode, setDisableCode] = useState(false);

    const { componentsDetail, componentsList, setComponentsDetail, setComponentsList, LoadSalaryStructure, LoadSalaryStructureDetailWithoutID } = useSalaryStructureDetailByID();

    // Parent Roll  Alert Values
    const [msgOpen, setMsgOpen] = useState(false);
    const [severityValue, setSeverityvalue] = useState('info');
    const [messageValue, setMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [alertTitleValue, setAlertTitleValue] = useState('');
    const [selectedButton, setSelectedButton] = useState(null);

    // Display Message
    const CallMessage = (serverityval, msg, title) => {
        setSeverityvalue(serverityval);
        setMessageValue(msg);
        setAlertTitleValue(title);
        setMsgOpen(true);
    };

    const { processIndent } = useSalaryStructureCRUD(CallMessage);
    const callback = () => { handlecallback(); }
    const [selectedRows, setSelectedRows] = useState([]);


    //-- get Project Number    
    const [salaryStructureName, setSalaryStructureName] = useState('');


    // Project Lead

    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [isDataSalaryComponentLoaded, setIsDataSalaryComponentLoaded] = useState(false);
    

    // const [componentsList, setComponentsList] = useState([]);


    const CustomTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} arrow placement="right-start" />
    ))({
        [`& .MuiTooltip-tooltip`]: {
            backgroundColor: colors.blueAccent[500],
            color: 'white',
            fontSize: '14px',
            borderRadius: '10px',
            padding: '10px',

        },
        [`& .MuiTooltip-arrow`]: {
            color: colors.blueAccent[500],
        },
    });

    // load edit mode salary structure list
    useEffect(() => {

        const loadSalaryStructureDetail = async () => {
            if (!isDataLoaded && editSalaryStructureID !== 0) {
                if (componentsDetail.length === 0) {
                    await LoadSalaryStructure(editSalaryStructureID);

                }
                else {

                    setIsDataLoaded(true);


                }
            }
        }
        loadSalaryStructureDetail();

    }, [editSalaryStructureID])


    useEffect(() => {
        if (componentsDetail.length > 0) {

            // salary structure name
            // setSalaryStructureName(componentsDetail.salaryStructureName);

            // comman data format
            const parseData = (data) => typeof data === 'string' ? JSON.parse(data) : data;

            // Handle Raw Material Rows
            const productData = parseData(componentsDetail);
            setComponentsList(Array.isArray(productData) ? productData : []);

            setSalaryStructureName(editSalaryStructureCode);
            setDisableCode(true);
        }
    }, [componentsDetail])


    // load salary components list DataSalaryComponentLoaded

    useEffect(() => {
        const loadSalaryComponents = async () => {
            if (!isDataSalaryComponentLoaded) {
                if (editSalaryStructureID === 0) {
                    await LoadSalaryStructureDetailWithoutID();
                    setDisableCode(false);
                }
            }
        }

        loadSalaryComponents();
    }, [editSalaryStructureID]);

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelectedRows = componentsList.map((row) => row.id_component);
            setSelectedRows(newSelectedRows);
            return;
        }
        setSelectedRows([]);
    };
    const handleRowCheckboxClick = (event, rowId) => {
        const selectedIndex = selectedRows.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedRows, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedRows.slice(1);
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelectedRows = selectedRows.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedRows.slice(0, selectedIndex),
                ...selectedRows.slice(selectedIndex + 1),
            ];
        }

        setSelectedRows(newSelectedRows);

    };

    const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;
    const [filters, setFilters] = useState({
        name: '',
        companyname: '',
        email: '',
        workphone: '',
        status: '',
        payales: '',
    });

    const filteredData = componentsList.filter((row) => {
        // Check if row matches selected status
        // if (selectedStatus === 'All' || row.status === selectedStatus) {
        // Check if all filter fields match
        return Object.keys(filters).every((key) => {
            if (filters[key] === '') return true; // No filter applied
            return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
        });
        // }
        return false;
    });



    const handleCallEdit = (value) => {


    };

    const handleCheckboxChange = (event, componentId, field) => {
        const updatedComponentsList = componentsList.map((component) => {
            if (component.id_component === componentId) {
                return {
                    ...component,
                    [field]: event.target.checked ? 'Y' : 'N', // Dynamically update based on the field
                };
            }
            return component;
        });

        setComponentsList(updatedComponentsList);
    };
    const handleValueChange = (event, componentId) => {
        const updatedComponentsList = componentsList.map((component) => {
            if (component.id_component === componentId) {
                return {
                    ...component,
                    value: event.target.value, // Update value based on TextField input
                };
            }
            return component;
        });

        setComponentsList(updatedComponentsList);
    };

    const handleApplicableRuleChange = (event, componentId) => {
        const updatedComponentsList = componentsList.map((component) => {
            if (component.id_component === componentId) {
                return {
                    ...component,
                    applicable_rule: event.target.value, // Update applicable_rule based on TextField input
                };
            }
            return component;
        });

        setComponentsList(updatedComponentsList);
    };


    // save salary componenets

    const handleSaveSalaryComponents = () => {
        let isValid = true;

        // validateion 
        if (salaryStructureName == '' || salaryStructureName == null) {
            isValid = false;
            CallMessage('info', 'Please enter salary structure name', 'Info');
        }

        // check selected table values

        let selectedDetails = componentsList.filter(comp => selectedRows.includes(comp.id_component));

        if (selectedDetails.length > 0) {
            for (let comp of selectedDetails) {
                if (comp.value === null || comp.value === 0) {
                    isValid = false;
                    break; // exit early once invalid data is found
                }
            }
        }

        const payload = {
            p_salary_structure_name: salaryStructureName,
            p_salary_structure_detail: selectedDetails,
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_user: localStorage.getItem('userID'),
            p_id_salary_structure: editSalaryStructureID,
            p_mode: editSalaryStructureID === 0 ? 0 : 1
        }
        processIndent(0, editSalaryStructureID, payload);

    }



    return (<>
        <Box>
            {/* <Header title={editPartyID == 0 ? 'New Salary Structure' : 'Edit Salary Structure'} subtitle="" callback={callback} /> */}

            <Grid container justifyContent="space-between" alignItems="center" padding={0} sx={{ backgroundColor: colors.primary[400] }}>
                {/* Left-aligned: Edit Employee */}
                <Grid item>
                    <Typography variant="h4" sx={{ textAlign: "center", width: "100%", marginLeft: "10px", alignItems: "center" }}>
                        {editSalaryStructureID == 0 ? 'New Salary Structure' : 'Edit Salary Structure'}
                    </Typography>
                </Grid>

                {/* Right-aligned: Buttons */}
                <Grid item>
                    <Grid container alignItems="center">
                        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                        {/* Save */}
                        <Grid item ml={1} mr={1}>
                            <Tooltip title="Add new orders">
                                <IconButton
                                    onClick={() => handleSaveSalaryComponents()}
                                    sx={{ display: 'flex', alignItems: 'center' }}
                                    type="submit"
                                >
                                    {editSalaryStructureID === 0 ? (
                                        <SaveAltIcon
                                            style={{
                                                fontSize: 18,
                                                color: selectedButton === 'save' ? 'yellow' : '#009688'
                                            }}
                                        />
                                    ) : (
                                        <EditIcon
                                            style={{
                                                fontSize: 18,
                                                color: selectedButton === 'save' ? 'yellow' : '#009688'
                                            }}
                                        />
                                    )}


                                    <Typography variant="body2" sx={{ ml: 1 }}>  {editSalaryStructureID === 0 ? 'Save' : 'Edit'}</Typography>
                                </IconButton>
                            </Tooltip>
                        </Grid>

                        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                        <IconButton onClick={callback}>
                            <Close style={{ fontSize: "14px", color: "#2196F3" }} />
                        </IconButton>
                        <Divider orientation="vertical" flexItem

                        />
                    </Grid>
                </Grid>
            </Grid>

            <Divider />

            {/* Message box detail */}
            <CallAlertBar parentRollMsgOpen={msgOpen} setParentRollMsgOpen={setMsgOpen} parentRollSeverityvalue={severityValue}
                setParentRollSeverityvalue={setSeverityvalue} parentRollAlertTitleValue={alertTitleValue}
                setParentRollAlertTitleValue={setAlertTitleValue} parentRollMessageValue={messageValue} setParentRollMessageValue={setMessageValue} />


            {/* Adjust screen size based on moniter */}
            <Box
                sx={{
                    padding: "5px",
                    borderRadius: "10px",
                    maxHeight: {
                        xs: '72vh', // Extra small devices (phones)
                        sm: '72vh', // Small devices (tablets)
                        md: '74vh', // Medium devices (small laptops)
                        lg: '74vh', // Large devices (desktops)
                        xl: '82vh', // Extra large devices (large desktops)
                    },
                    overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                    '&::-webkit-scrollbar': {
                        width: '8px',
                    },
                    '&::-webkit-scrollbar-track': {
                        background: colors.primary[400],
                        borderRadius: '10px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: colors.blueAccent[600],
                        borderRadius: '10px',
                        '&:hover': {
                            background: colors.blueAccent[800],
                        },
                    },
                    '&::-webkit-scrollbar-corner': {
                        background: colors.primary[700],
                    }
                }}>

                <Grid container  >
                    <Grid item xs={12} sm={12} md={12} lg={8} xl={6} >
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <Grid container padding="0px 0px 0px 10px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2} display="flex-start" justifyContent="center">
                                    <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Salary Structure Name
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={11} md={3.8} lg={5} xl={5}>
                                    <TextField value={salaryStructureName} disabled={disableCode} onChange={(e) => { setSalaryStructureName(e.target.value) }} fullWidth size="small" label="" required variant="outlined" />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>


                    {/* select components in table */}
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={0.5}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <Grid container padding="0px 0px 10px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} display="flex-start" justifyContent="center">
                                    <Divider />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <Grid container padding="0px 0px 0px 10px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} display="flex-start" justifyContent="center">
                                <Typography>Salary Structure Components</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <Grid container padding="10px 0px 10px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} display="flex-start" justifyContent="center">
                                    <Divider />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <Grid container padding="0px 0px 10px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} display="flex-start" justifyContent="center">
                                    <Box
                                        gridColumn="span 9"
                                        gridRow="span 2"
                                        alignItems="center"
                                        justifyContent="center"
                                        padding={0.5}
                                        sx={{
                                            "& .MuiTable-root": {
                                                border: "none",
                                                size: "small",
                                            },
                                            "& .MuiTableCell-root": {
                                                borderBottom: "none",
                                                border: "1px solid",
                                                borderColor: `${colors.primary[400]} !important`,
                                                padding: "4px", // Reduce padding
                                                fontSize: "12px", // Smaller font size
                                            },
                                            "& .MuiCheckbox-root": {
                                                color: `${colors.blueAccent[200]} !important`,
                                                size: "small",
                                                padding: "2px", // Reduce checkbox padding
                                            },
                                            "& .MuiTableFooter-root": {
                                                borderTop: "none",
                                                backgroundColor: colors.blueAccent[700],
                                                height: "8px", // Smaller height
                                            },
                                            "& .MuiButton-text": {
                                                color: `${colors.grey[100]} !important`,
                                            },
                                        }}
                                    >
                                        <TableContainer>
                                            <Table size="small">
                                                <TableHead sx={{ height: 8 }}>
                                                    <TableRow>
                                                        <TableCell>
                                                            <Checkbox
                                                                size="small"
                                                                style={{ color: "secondary" }}
                                                                indeterminate={selectedRows.length > 0 && selectedRows.length < filteredData.length}
                                                                checked={selectedRows.length === filteredData.length}
                                                                onChange={handleSelectAllClick}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ textAlign: "center", fontSize: "12px" }}>COMPONENT NAME</TableCell>
                                                        <TableCell sx={{ textAlign: "center", fontSize: "12px" }}>COMPONENT TYPE</TableCell>
                                                        <TableCell sx={{ textAlign: "center", fontSize: "12px" }}>TAXABLE</TableCell>
                                                        <TableCell sx={{ textAlign: "center", fontSize: "12px" }}>FIXED COMPONENT</TableCell>
                                                        <TableCell sx={{ textAlign: "center", fontSize: "12px" }}>VALUE</TableCell>
                                                        <TableCell sx={{ textAlign: "center", fontSize: "12px" }}>APPLICABLE RULE</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {componentsList.map((row) => (
                                                        <TableRow key={row.id}>
                                                            <TableCell>
                                                                <Checkbox
                                                                    size="small"
                                                                    checked={isSelected(row.id_component)}
                                                                    onChange={(event) => handleRowCheckboxClick(event, row.id_component)}
                                                                />
                                                            </TableCell>
                                                            <TableCell
                                                                sx={{
                                                                    fontSize: "12px",
                                                                    padding: "4px",
                                                                }}
                                                            >
                                                                <span
                                                                    style={{
                                                                        color: "teal",
                                                                        textDecoration: "underline",
                                                                        cursor: "pointer",
                                                                        padding: "2px", // Reduce span padding
                                                                    }}
                                                                    onClick={() => handleCallEdit(row.id_component)}
                                                                >
                                                                    {row.component_name}
                                                                </span>
                                                            </TableCell>
                                                            <TableCell sx={{ fontSize: "12px", textAlign: "center", padding: "4px" }}>
                                                                {row.component_type}
                                                            </TableCell>
                                                            <TableCell sx={{ textAlign: "center", padding: "4px" }}>
                                                                <Checkbox
                                                                    size="small"
                                                                    checked={row.taxable_yn === "Y"}
                                                                    onChange={(event) => handleCheckboxChange(event, row.id_component, "taxable_yn")}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ textAlign: "center", padding: "4px" }}>
                                                                <Checkbox
                                                                    size="small"
                                                                    checked={row.fixed_component_yn === "Y"}
                                                                    onChange={(event) => handleCheckboxChange(event, row.id_component, "fixed_component_yn")}
                                                                />
                                                            </TableCell>
                                                            <TableCell>
                                                                <TextField
                                                                    sx={{
                                                                        "& .MuiOutlinedInput-notchedOutline": {
                                                                            border: "none",
                                                                        },
                                                                        "& .MuiInputBase-input": {
                                                                            padding: "2px", // Reduce input padding
                                                                            fontSize: "12px", // Smaller font size
                                                                            textAlign: "right",
                                                                        },
                                                                    }}
                                                                    type="number"
                                                                    value={row.value}
                                                                    onChange={(event) => handleValueChange(event, row.id_component)}
                                                                    size="small"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                />
                                                            </TableCell>
                                                            <TableCell>
                                                                <TextField
                                                                    sx={{
                                                                        "& .MuiOutlinedInput-notchedOutline": {
                                                                            border: "none",
                                                                        },
                                                                        "& .MuiInputBase-input": {
                                                                            padding: "2px",
                                                                            fontSize: "12px", // Smaller font size
                                                                            textAlign: "center",
                                                                        },
                                                                    }}
                                                                    disabled
                                                                    value={row.applicable_rule}
                                                                    size="small"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                                {/* <TableFooter>
                                                    <TableRow>
                                                        <TableCell colSpan={5} sx={{ textAlign: 'right', fontWeight: 'bold', fontSize: "12px" }}>
                                                            Total
                                                        </TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold', fontSize: "12px", textAlign: 'right' }}>
                                                            {componentsList.reduce((sum, row) => sum + (parseFloat(row.value) || 0), 0).toFixed(2)}
                                                        </TableCell>
                                                        <TableCell /> 
                                                    </TableRow>
                                                </TableFooter> */}

                                            </Table>

                                        </TableContainer>
                                        <Box mt={2} p={2} sx={{ backgroundColor: colors.primary[400], borderRadius: "8px", fontSize: "14px" }}>
                                            <Typography variant="subtitle2" gutterBottom>📊 <b>Summary</b></Typography>
                                            <Typography sx={{ mb: 1 }}>
                                                <b>Gross Earnings</b> = {
                                                    componentsList
                                                        .filter(comp => comp.component_type === "Earnings")
                                                        .map(comp => `₹${comp.value} (${comp.component_name})`)
                                                        .join(" + ")
                                                } = ₹{componentsList
                                                    .filter(comp => comp.component_type === "Earnings")
                                                    .reduce((sum, comp) => sum + (parseFloat(comp.value) || 0), 0).toFixed(2)}
                                            </Typography>

                                            <Typography sx={{ mb: 1 }}>
                                                <b>Deductions</b> = {
                                                    componentsList
                                                        .filter(comp => comp.component_type === "Deductions")
                                                        .map(comp => `₹${comp.value} (${comp.component_name})`)
                                                        .join(" + ")
                                                } = ₹{componentsList
                                                    .filter(comp => comp.component_type === "Deductions")
                                                    .reduce((sum, comp) => sum + (parseFloat(comp.value) || 0), 0).toFixed(2)}
                                            </Typography>

                                            <Typography>
                                                <b>Net Salary (Take-home)</b> = ₹{
                                                    componentsList
                                                        .filter(comp => comp.component_type === "Earnings")
                                                        .reduce((sum, comp) => sum + (parseFloat(comp.value) || 0), 0)
                                                    -
                                                    componentsList
                                                        .filter(comp => comp.component_type === "Deductions")
                                                        .reduce((sum, comp) => sum + (parseFloat(comp.value) || 0), 0)
                                                        .toFixed(2)}
                                            </Typography>
                                        </Box>

                                    </Box>

                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>

                    {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={2}>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <Grid container padding="10px 0px 10px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} display="flex-start" justifyContent="center">
                                    <Divider />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Box sx={{ display: "flex", justifyContent: "flex-end", marginRight: "10px" }}>
                                <Button variant="contained" color="secondary" size="small">Save</Button>
                            </Box>
                        </Grid>

                        <Box padding={1} sx={{backgroundColor:colors.primary[400]}}>
                                                <Typography>Gross Earnings = ₹ {10000}</Typography>
                                                <Typography>Deductions = ₹ {10000}</Typography>
                                                <Typography>Net Salary (Take-home)  = ₹ {10000}</Typography>
                                            </Box>

                    </Grid> */}

                </Grid>

            </Box>
        </Box>

    </>)
}
export default AddNewSalaryStructure;